(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brokerage-location', {
            parent: 'entity',
            url: '/brokerage-location?page&sort&search',
            data: {
                authorities: ['BROKERAGE_LOCATION_READ'],
                pageTitle: 'valueconnectApp.brokerageLocation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage-location/brokerage-locations.html',
                    controller: 'BrokerageLocationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerage');
                    $translatePartialLoader.addPart('brokerageRegion');
                    $translatePartialLoader.addPart('brokerageLocation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brokerage-location-detail', {
            parent: 'entity',
            url: '/brokerage-location/{id}',
            data: {
                authorities: ['BROKERAGE_LOCATION_READ'],
                pageTitle: 'valueconnectApp.brokerageLocation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage-location/brokerage-location-detail.html',
                    controller: 'BrokerageLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerage');
                    $translatePartialLoader.addPart('brokerageRegion');
                    $translatePartialLoader.addPart('brokerageLocation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrokerageLocation', function($stateParams, BrokerageLocation) {
                    return BrokerageLocation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('brokerage-location.new', {
            parent: 'brokerage-location',
            url: '/new',
            data: {
                authorities: ['BROKERAGE_LOCATION_CREATE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-location/brokerage-location-dialog.html',
                    controller: 'BrokerageLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('address');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                officeName: null,
                                disabled: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brokerage-location', null, { reload: true });
                }, function() {
                    $state.go('brokerage-location');
                });
            }]
        })
        .state('brokerage-location.edit', {
            parent: 'brokerage-location',
            url: '/{id}/edit',
            data: {
                authorities: ['BROKERAGE_LOCATION_UPDATE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-location/brokerage-location-dialog.html',
                    controller: 'BrokerageLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('address');
                            return $translate.refresh();
                        }],
                        entity: ['BrokerageLocation', function(BrokerageLocation) {
                            return BrokerageLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brokerage-location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brokerage-location.delete', {
            parent: 'brokerage-location',
            url: '/{id}/delete',
            data: {
                authorities: ['BROKERAGE_LOCATION_DESTROY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage-location/brokerage-location-delete-dialog.html',
                    controller: 'BrokerageLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrokerageLocation', function(BrokerageLocation) {
                            return BrokerageLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brokerage-location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
